import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import parse from "html-react-parser";
import React from "react";

import "./JUMBOformModals.scss";
const JUMBOformGlobalModal = ({ title, text, link, buttonText }) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  return (
    <div className="jumbo-form-global-modal">
      <div className="title">
        <div className="icon-image-div">
          <Icon name={"jform-black"} />
        </div>
        <span>JUMBOforms</span>
      </div>
      <div className="body-content">
        <div className="title">{getTextByKey(title)}</div>
        <div className="text">{parse(getTextByKey(text))}</div>
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <Button className="new-button embed-button" green>
              {buttonText}
            </Button>
          </a>
        ) : (
          <Button
            className="new-button embed-button"
            onClick={() => closeModal()}
          >
            {getTextByKey("ok")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default JUMBOformGlobalModal;
